<script setup>
import {computed, onMounted, ref, watch} from "vue";
import axios from "@/axios";
import {useLanguageStore} from "@/pinia";
import {formatDate} from "@/plugins/dayjs";

const props = defineProps([
    'defaultMeetingId',
    'set_ageId',
    'meetingType',
    'label',
])
const emits = defineEmits(['set_meetingId'])
const meetings = ref([]);
const selectedMeetingId = ref(null);
const languageStore = useLanguageStore();
const getData = ()=>{
  axios.get("/api/meeting?size=500")
      .then((s)=>{
        meetings.value= s.data.content;
      })
      .catch(e=>console.log(e))
}
const getMeetingData = ()=>{
  axios.get("/api/meeting/meetingType/"+props.meetingType)
      .then((s)=>{
        meetings.value = s.data;
      })
}

const enhancedMeetings = computed(() => {
  return meetings.value
    .map(m => {
      let title = formatDate(m?.meetingPreDt, 'YYYY-MM-DD') +"-"+m.meetingType?.codeNm+"-"+m.meetingLocation?.codeNm;
      return { ...m, meetingTitle: title };
    })
    .sort((a, b) => new Date(b.meetingPreDt) - new Date(a.meetingPreDt));
})

const fn_change = ()=>{
  emits('set_meetingId', selectedMeetingId.value);
}
watch(()=>props.meetingType, ()=>{
  selectedMeetingId.value = "";
  if(props.meetingType != null || props.meetingType != 'mt000'){
    getMeetingData()
  }
})

onMounted(()=>{
  if(props.meetingType && props.meetingType != 'mt000'){
    getMeetingData()
  }else{
    getData()
  }
  selectedMeetingId.value= props.defaultMeetingId
})
</script>

<template>
  <v-select
      v-model="selectedMeetingId"
      @update:modelValue="fn_change"
      :items="enhancedMeetings"
      item-title="meetingTitle"
      item-value="meetingId"
      :label="label"
      :placeholder="!label ? languageStore.get('select') : undefined"
      variant="outlined"
      density="compact"
      hide-details="auto"
  />
</template>

<style scoped>

</style>